import "./OurTeam.module.css";
import Header from "@/reusable_sections/Header";
import OurStoryIntroduction from "./sections/OurStoryIntroduction";
import OurExpertTeam from "./sections/OurExpertTeam";
import Hero from "./sections/Hero";
import Footer from "@/reusable_sections/Footer";
export default function OurTeamPage() {
  return <div>
      <Header />
      <OurStoryIntroduction />
      <OurExpertTeam />
      <Hero />
      <Footer />
    </div>;
}